import React from 'react'
import { t } from '@lingui/macro'
import { Link } from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { EXTERNAL_LINKS } from 'constants/externalLinks'

import classes from './ImageGuidelineLink.module.scss'

const ImageGuidelineLink: React.FC = () => (
  <div className={classes.guidelineLink}>
    <OpenInNewIcon fontSize={'small'} className={classes.linkIcon} />
    <Link
      href={EXTERNAL_LINKS.BRAND_GUIDELINES}
      target="_blank"
      rel="noopener"
      className={classes.inlineLink}
    >
      <span>{t`link.label.guideline_product_images`}</span>
    </Link>
  </div>
)

export default ImageGuidelineLink
